export default __webpack_public_path__ + "static/media/Ζeniθ_ΗΛ.f8b79b1b.png";